import Vue from 'vue'
import axios from 'axios'
import { API_URL } from '@/config/api-config'
import { TokenService } from './localStorage'


axios.interceptors.response.use(
  response => response,
  async error => {

    if (error.response && error.response.status === 500) {
      const userData = JSON.parse(localStorage.getItem("Information Connexion"));
      const router = Vue.$router;
      const logout = (router) => {
        localStorage.removeItem("TOKEN_KEY");
        localStorage.removeItem("Information Connexion");
        router.push({ name: "Login" });
      };

      Swal.fire({
        title: "Session expirée",
        text: "Votre session a expiré. Voulez-vous vous reconnecter ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, reconnecter",
        cancelButtonText: "Non, déconnecter",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetchLogin(userData);
            const newToken = response.data.body;
            localStorage.setItem("TOKEN_KEY", JSON.stringify(newToken));
            Swal.fire("Succès", "Session renouvelée avec succès !", "success");
          } catch (error) {
            logout(router);
          }
        } else {
          logout(router);
        }
      });
    }

    return Promise.reject(error);
  }
);


export const initAxios = () => {
  axios.defaults.baseURL = API_URL
  Vue.prototype.$axios = axios
}

export function uploadFile(
    url,
    file,
    method='POST',
    fileKey='file',
    onStatusChange=() => {},
    onProgress=() => {}
  ){
    
  if (!url || url === '') {
    console.log('Please provide the target url')
  }
  else if (!method || method === '') {
    console.log('Please provide file upload url ( POST / PUT )')
  }
  let formData = new FormData()

  //Send request only when user choosed a file
  if(file)
    formData.append(fileKey, file);


  console.log('Default upload mode')
  var xhr = new XMLHttpRequest()
  xhr.open(method, url)

  xhr.onreadystatechange = (e) => {
    if(xhr.readyState == 4) {
      if(xhr.status !== 200){
        onStatusChange({ 'error' : {
          message: xhr.statusText,
          event: e
        } })
      }
      else {
        onStatusChange('success', e)
      }
    }
  }
  xhr.upload.onprogress = (oEvent) => {
    if (oEvent.lengthComputable) {
      let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
      console.log(percentComplete)
      onStatusChange({ 'progress': percentComplete })
      onProgress(percentComplete)
    }
    else {
      // Unable to compute progress information since the total size is unknown
      onProgress(false)
      onStatusChange({ 'progress': false })
    }
  },
  xhr.send(formData)
}

export function downloadFile(url, filename='filen.pdf', onProgress=() => {}) {
  const authHeader = TokenService.getAuthorization();

  return new Promise((resolve,reject) => {
    axios.get(url, {
      responseType: 'blob',
      headers: {
        Authorization: authHeader
      },
      onDownloadProgress: progressEvent => {
        const total = parseFloat(progressEvent.total)
        const current = progressEvent.loaded
        let percentCompleted = Math.floor(current / total * 100)
        console.log('completed: ', percentCompleted)
        onProgress(percentCompleted)
      }
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]))
      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.setAttribute('download', filename)
      document.body.appendChild(fileLink)

      fileLink.click()
      resolve(fileURL)
    }).catch(err=> { reject(err) })
  }) 
}

export function fetchLogin (credentials) {
  return axios.post('/user/signIn', credentials)
}

export function fetchSignUp (credentials) {
  alert()
  return axios.post("/user/signUp", credentials);
}

export function post (url, creds) {
  const authHeader = TokenService.getAuthorization();

  return axios.post(url, creds, {
      headers: {
        Authorization: authHeader
      }
    }
  )
}

export function put (url, creds) {
  const authHeader = TokenService.getAuthorization();
  return axios.put(url, creds, {
      headers: {
        Authorization: authHeader
      }
    }
  )
}
export function patch (url, creds) {
  const authHeader = TokenService.getAuthorization();
  return axios.patch(url, creds, {
      headers: {
        Authorization: authHeader
      }
    }
  )
}

export function get (url) {
  const authHeader = TokenService.getAuthorization();
  return axios.get(url, {
    headers: {
        Authorization: authHeader
      }
    }
  )
}

export function remove (url) {
  const authHeader = TokenService.getAuthorization();
  return axios.delete(url, {
    headers: {
        Authorization: authHeader
      }
    }
  )
}

export const api = {
  delete: remove,
  remove,
  get,
  post,
  patch,
  put
}
